const endpoint = '/item-service/api/external/promocodes';

export const promoCodesContext = {
  get: `${endpoint}/`,
  getById: `${endpoint}/{id}`,
  create: `${endpoint}/`,
  update: `${endpoint}/{id}`,
  remove: `${endpoint}/{id}`,
};
